<template>
  <div v-if="expenseItems.length == 0" class="notification">
    No records found.
  </div>

  <div v-for="(groupedItems, i) in groupedDisplayedItems" :key="i">
    <h3 class="title is-6 mb-1">
      {{ $options.serialNumberToDate(groupedItems[0][0]).toLocaleDateString() }}
    </h3>
    <hr class="my-1" />
    <ul class="mb-5 pl-2">
      <li v-for="(item, j) in groupedItems" :key="j">
        <div class="is-flex is-justify-content-space-between">
          <span>{{ item[1] }}</span>
          <span class="has-text-weight-semibold has-text-danger-dark"
            >-{{ $options.numberFormat.format(item[2]) }}</span
          >
        </div>
        <p v-if="item[8]" class="is-size-7 has-text-grey mb-1">{{ item[8] }}</p>
        <div class="tags">
          <span v-if="item[3]" class="tag is-link is-light">{{ item[3] }}</span>
          <span v-if="item[4]" class="tag is-info is-light">{{ item[4] }}</span>
          <span v-if="item[5]" class="tag is-success is-light">{{
            item[5]
          }}</span>
          <span v-if="item[5]" class="tag is-warning is-light">{{
            item[7]
          }}</span>
          <span v-if="item[6]" class="tag is-light">{{ item[6] }}</span>
        </div>
      </li>
    </ul>
  </div>

  <button v-if="hasMoreItems" class="button" @click="page += 1">
    Load More
  </button>
</template>

<script>
import { groupBy } from 'lodash-es';
import { serialNumberToDate } from '@/utils';
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('balanceSheet');
const PER_PAGE = 25;

export default {
  numberFormat: new Intl.NumberFormat(),
  serialNumberToDate,

  data() {
    return {
      page: 1,
    };
  },

  computed: {
    ...mapState(['expenseItems']),

    hasMoreItems() {
      return this.expenseItems.length > this.displayedItems.length;
    },

    displayedItems() {
      return [...this.expenseItems].reverse().slice(0, this.page * PER_PAGE);
    },

    groupedDisplayedItems() {
      return groupBy(this.displayedItems, item =>
        serialNumberToDate(item[0]).toLocaleDateString()
      );
    },
  },
};
</script>

<style scoped>
ul li:not(:last-child) {
  margin-bottom: 0.35rem;
  padding-bottom: 0.35rem;
  border-bottom: 1px solid #f5f5f5;
}
</style>
